import * as React from 'react';

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var SvgCaretDown = function SvgCaretDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    className: "zig-icon",
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 13.46 7.86",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: props.color,
    d: "M6.85 7.86a.76.76 0 0 1-.54-.23l-6-6.27A.752.752 0 0 1 1.19.14a.7.7 0 0 1 .2.22l5.45 5.71L12.27.36a.75.75 0 0 1 1.08 1l-6 6.27a.78.78 0 0 1-.54.23Z",
    className: "cls-1"
  }));
};

export { SvgCaretDown as ReactComponent };
